/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-05-09 09:24:59
 * @LastEditors: 317473294@qq.com
 * @LastEditTime: 2023-11-14 14:10:19
 * @FilePath: /english_admin_v1.1.0/src/router/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * @Author: 317473294@qq.com
 * @Date: 2022-03-04 16:23:29
 * @LastEditTime: 2023-05-11 17:04:20
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Description: 
 * @FilePath: /zdzyframe_menhu/src/router/index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import dragTest from '@/components/dragTest'
import echartsTest from '@/components/echartsTest'
import Home from '@/views/home/index.vue'
import word from '@/views/word/index.vue'


import layout from '@/layout/layout'
import Login from '@/views/login/login'

import { asyRouterList } from "./test.js"
import { tranArrToTreeData,getRoleMenuIds } from "@/router/dtRouter.js"

import {currentRouterToMeta} from "@/utils/golobal.js"

Vue.use(Router)
const staticRouter = [

  {
    path: '/',//默认登录页
    hidden: false,
    // redirect:'/login',
    component: resolve => require(["@/views/login/login"], resolve)
    // component:()=> import('@/views/login/login.vue')
    // component: () => import('@/views/login/login.vue'),
  },
  {
    path: '/login',//默认登录页
    name: 'Login',
    hidden: false,
    component: resolve => require(["@/views/login/login"], resolve)
  },
  {
    path: '*',//默认登录页
    name: '404',
    hidden: false,
    component: resolve => require(["@/views/404.vue"], resolve)
  },
]
// staticRouter.push(...asyRouterList)
const router = new Router({
  routes: staticRouter,
  mode: 'history',
  //作用：每次做路由切换时，都会让新的页面在最顶部
  scrollBehavior(to, from, savePosition) {
    return { x: 0, y: 0 }
  }
})
//刷新重新获取路由权限信息，可能后台修改了，刷新一下，重新拉取

let userinfo=localStorage.getItem('userinfo')
if(userinfo){
  //重新拉取菜单
  
  // getRoleMenuIds(JSON.parse(userinfo).roleid).then((res)=>{
  // let menuTree = tranArrToTreeData(res)
  // console.log("用户信息",res)
  // router.addRoutes(res)
  // })
}
let menus = localStorage.getItem("menus")
if (menus) {
  let menusToJson = JSON.parse(menus)
  let menuTree = tranArrToTreeData(menusToJson)
  router.addRoutes(menuTree)
}

// let kk=JSON.parse(menus)
// kk.component=layout
// console.log(kk.redirect)
// if(menus){
//   router.addRoutes([kk])
// }

//路由守卫
router.beforeEach((to, from, next) => {
  console.log("当前路由",to)
  
// 获取存储的Token
  currentRouterToMeta(to)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isUserLoggedIn()) { // 判断用户是否已经登录
      // 如果用户未登录，则重定向到登录页面
      next({
        path: '/login',
        // 通过 query 参数将目标路由路径传递给登录页面，以便登录成功后可以跳转回原来的页面
        query: { redirect: to.fullPath }
      })
    } else {
      next() // 用户已登录，继续访问该页面
    }
  } else {
    console.log("无需登陆直接访问", to)
    if (to.path != '/login') {
      // 如果该页面无需登录即可访问，则直接访问该页面
      next({
        path: '/login',//第一次：跳转到登陆页
        // 通过 query 参数将目标路由路径传递给登录页面，以便登录成功后可以跳转回原来的页面
        query: { redirect: to.fullPath }
      })
    } else {//第二：路由守卫到进来的是登陆页，直接访问
      next()
    }
  }
})
///
function isUserLoggedIn() {
  const isLogin = localStorage.getItem('token')
  return isLogin ? true : false;
}
////
// router.beforeEach((to,from,next)=>{
//   const requiresAuth=to.matched.some(record=>record.meta.requiresAuth)
//     const isLogin = localStorage.getItem('token') // 假设该项目使用 token 来验证登录状态
//     if (requiresAuth && !isLogin) {
//       next({      
//       path: '/login',//默认登录页
//       // query:{redirect:to.fullPath}, 
//     })
//     } else {
//       next()
//     }
//   })


//导出
export default router
// export default {
//   router,
//   asyncMenuRouter
// };





// WEBPACK FOOTER //
// ./src/router/index.js